import { createFileRoute } from '@tanstack/react-router';
import { CustomerVerificationPage } from '../components/pages/SettingsPage/CustomerVerificationPage';

export const Route = createFileRoute('/account/settings_/kyc')({
  component: CustomerVerificationPage,
});
